import { DateTimeProps, GenericDateTime } from "components/Form/components/GenericDateTime/GenericDateTime";

export const Date = (props: DateTimeProps) => (
    <GenericDateTime
        {...props}
        type="date"
    />
);